export default __webpack_public_path__ + "static/edutech-aus-fa6860c58cdb8ccb628420d00c64a27f.png";